import React from 'react';
import PropTypes from 'prop-types';
import { getSupportCopyShop3527 } from 'site-modules/shared/utils/incentives/electric-car-incentives';

export function SupportCopyShop3527({
  transactionTypeFilter = '',
  isCompletedWizardFlow = false,
  primary = false,
  compatibleIncentiveIds = [],
  rebateOverridesByEligibility = [],
  subtypeId = undefined,
}) {
  const { className, text } = getSupportCopyShop3527({
    transactionTypeFilter,
    isCompletedWizardFlow,
    primary,
    compatibleIncentiveIds,
    rebateOverridesByEligibility,
    subtypeId,
  });

  return <div className={className}>{text}</div>;
}

SupportCopyShop3527.propTypes = {
  primary: PropTypes.bool,
  compatibleIncentiveIds: PropTypes.arrayOf(PropTypes.string),
  rebateOverridesByEligibility: PropTypes.arrayOf(PropTypes.shape({})),
  subtypeId: PropTypes.number,
  transactionTypeFilter: PropTypes.string,
  isCompletedWizardFlow: PropTypes.bool,
};
